import { takeLatest, all, call, put } from 'redux-saga/effects';
import {
    startAllMyLeavesData,
    setAllMyLeavesData,
    startAllLeavesData,
    startUpdateLeaveStatus,
    setAllLeavesData,
    startEmployeeeLeaveSummaryDetails,
    setEmployeeeLeaveSummaryDetails,
    setEmployeesListLeaveSummary,
    startEmployeeLeavesData,
    setEmployeeLeavesData,
    startSingleLeaveData,
    setSingleLeaveData,
    startAddOrApproveEditLeave,
    startAddLeaveByAdmin,
    startFindingOverlappingDates,
    setLeavesOverlapping,
    startDeleteLeave,
    completedFetch,
    startAddRestoreLeave,
    fetchEmployeeLeaveData,
    setEmployeeLeavesDropdown
} from './leavesData.Slice.Selector';
//
import { setNotificationAction } from '../NotificationStore/notification.slice.selector';

//API's
import { changeRecordData } from '../../Api/api';
import {
    leaveData,
    allLeavesData,
    singleLeaveData,
    addOrEditorApproveLeave,
    leaveByAdmin,
    deleteLeaveData,
    employeeLeavesdata,
    findTheOverLappingDates,
    findTheEmployeesleaveGroupBy,
    updateLeaveStatus,
    employeeLeaveDropdownAPI
} from '../../Api/LeaveAPI/leavesAPI';

function* employeeLeaveDropdownWatcher() {
    yield takeLatest(fetchEmployeeLeaveData.type, setEmployeeLeaveDropdown);
}

function* setEmployeeLeaveDropdown() {
    try {
        let data = yield call(employeeLeaveDropdownAPI);
        yield put(setEmployeeLeavesDropdown(data));
    } catch (error) {
        yield put(
            setNotificationAction({
                message: error.response.data.message,
                variant: 'error'
            })
        );
    }
}

//(1) Watcher
function* startAllLeaveData() {
    yield takeLatest(startAllLeavesData.type, setAllData);
}
//(1) Next
function* setAllData({ payload }) {
    try {
        let allLeaveDatas;

        if (payload && payload.pageSize && payload.pageIndex) {
            allLeaveDatas = yield call(
                allLeavesData,
                payload.pageSize,
                payload.pageIndex,
                payload.empId,
                payload.start_date,
                payload.end_date,
                payload.approval_status
            );
        } else {
            allLeaveDatas = yield call(leaveData);
        }

        yield put(setAllLeavesData(allLeaveDatas));
        yield put(completedFetch());
    } catch (error) {
        yield put(
            setNotificationAction({
                message: error.response.data,
                variant: 'error'
            })
        );
        yield put(completedFetch());
    }
}

function* myLeaveDataWatcher() {
    yield takeLatest(startAllMyLeavesData.type, setAllMyLeaves);
}

function* setAllMyLeaves(payload) {
    try {
        let data = yield call(leaveData, payload.payload);
        yield put(setAllMyLeavesData(data));
        yield put(completedFetch());
    } catch (error) {
        yield put(
            setNotificationAction({
                message: error.response.data.message,
                variant: 'error'
            })
        );
        yield put(completedFetch());
    }
}

//(2) Watcher
function* startSingleData() {
    yield takeLatest(startSingleLeaveData.type, setSingleData);
}
//(2) Next
function* setSingleData({ payload }) {
    try {
        const data = yield call(singleLeaveData, payload);
        yield put(setSingleLeaveData(data));
        yield put(completedFetch());
    } catch (error) {
        yield put(
            setNotificationAction({
                message: error.message,
                variant: 'error'
            })
        );
        yield put(completedFetch());
    }
}
//(3) Watcher
function* startAddEditLeaveWatcher() {
    yield takeLatest(startAddOrApproveEditLeave.type, setupLeaveDataAddEdit);
}
//(3) Next
function* setupLeaveDataAddEdit({ payload }) {
    try {
        yield call(addOrEditorApproveLeave, payload);

        const path = window.location.pathname || '';

        if (path.includes('/my-leaves')) {
            yield put(startAllMyLeavesData());
        } else {
            yield put(startAllLeavesData({ pageSize: 10, pageIndex: 1 }));
        }

        yield put(
            setNotificationAction({
                message: 'Successfully Updated',
                variant: 'success'
            })
        );
        yield put(completedFetch());
    } catch (error) {
        yield put(
            setNotificationAction({
                message: error.message,
                variant: 'error'
            })
        );
        yield put(completedFetch());
    }
}

//(3) Watcher (for admin)
function* startAddEditLeaveWatcherAdmin() {
    yield takeLatest(startAddLeaveByAdmin.type, setupLeaveDataAddEditAdmin);
}
//(3) Next (for admin)
function* setupLeaveDataAddEditAdmin({ payload }) {
    try {
        yield call(leaveByAdmin, payload);
        yield put(
            startAllLeavesData({
                pageSize: 10,
                pageIndex: 1,
                empId: '-1',
                start_date: '',
                end_date: '',
                approval_status: '-1'
            })
        );
        yield put(
            setNotificationAction({
                message: 'Successfully Updated',
                variant: 'success'
            })
        );
        yield put(completedFetch());
    } catch (error) {
        yield put(
            setNotificationAction({
                message: error.message,
                variant: 'error'
            })
        );
        yield put(completedFetch());
    }
}

//(4)Watcher
function* startLeaveDelete() {
    yield takeLatest(startDeleteLeave.type, setUpForDelete);
}
//(4)
function* setUpForDelete({ payload }) {
    try {
        yield call(deleteLeaveData, payload);

        const path = window.location.pathname;

        if (path.includes('/my-leaves')) {
            yield put(startAllMyLeavesData());
        } else {
            yield put(startAllLeavesData({ pageSize: 10, pageIndex: 1 }));
        }

        yield put(
            setNotificationAction({
                message: 'Successfully Deleted',
                variant: 'success'
            })
        );
        yield put(completedFetch());
    } catch (error) {
        yield put(
            setNotificationAction({
                message: error.message,
                variant: 'error' // Changed from "success" to "error"
            })
        );
        yield put(completedFetch());
    }
}
//(5) Watcher
function* startAllEmployeeLeaveData() {
    yield takeLatest(startEmployeeLeavesData.type, setAllEmployeeLeavesData);
}
//(5) Next
function* setAllEmployeeLeavesData({ payload }) {
    try {
        const allLeaveDatas = yield call(employeeLeavesdata, payload);
        yield put(setEmployeeLeavesData(allLeaveDatas));
        yield put(completedFetch());
    } catch (error) {
        yield put(
            setNotificationAction({
                message: error.message,
                variant: 'error'
            })
        );
        yield put(completedFetch());
    }
}

//(6) Watcher For Add  Leave Restore
function* start_startAddRestoreLeave() {
    yield takeLatest(startAddRestoreLeave.type, set_startAddRestoreLeave);
}
//(6)Next
function* set_startAddRestoreLeave({ payload }) {
    try {
        yield call(changeRecordData, payload);

        yield put(
            setNotificationAction({
                message: 'Successfully Updated',
                variant: 'success'
            })
        );
        yield put(completedFetch());
    } catch (error) {
        yield put(
            setNotificationAction({
                message: error.message,
                variant: 'error'
            })
        );
        yield put(completedFetch());
    }
}

//(7) Watcher For Overlappping leaves dates
function* start_starOverlapppingLeave() {
    yield takeLatest(startFindingOverlappingDates.type, set_startOverlapppingLeave);
}
// startFindingOverlappingDates,
//   setLeavesOverlapping,
//(7)Next
function* set_startOverlapppingLeave({ payload }) {
    try {
        const data = yield call(findTheOverLappingDates, payload);
        yield put(setLeavesOverlapping(data));

        yield put(completedFetch());
    } catch (error) {
        yield put(
            setNotificationAction({
                message: error.message,
                variant: 'error'
            })
        );
        yield put(completedFetch());
    }
}

//(8) Watcher For Overlappping leaves dates
function* start_EmployeeeLeaveSummaryDetails() {
    yield takeLatest(startEmployeeeLeaveSummaryDetails.type, set_startEmployeeeLeaveSummaryDetails);
}
// startFindingOverlappingDates,
//   setLeavesOverlapping,
//(8)Next
function* set_startEmployeeeLeaveSummaryDetails({ payload }) {
    try {
        const data = yield call(findTheEmployeesleaveGroupBy, payload);
        if (payload.employee_id < 0) {
            yield put(setEmployeesListLeaveSummary(data));
        } else {
            yield put(setEmployeeeLeaveSummaryDetails(data));
        }
        yield put(completedFetch());
    } catch (error) {
        yield put(
            setNotificationAction({
                message: error.message,
                variant: 'error'
            })
        );
        yield put(completedFetch());
    }
}

// update leave status
function* updateLeaveApproveReject({ payload }) {
    try {
        const { id, payload: statusPayload, pageSize, pageIndex } = payload;

        yield call(updateLeaveStatus, id, statusPayload);

        if (pageSize && pageIndex) {
            yield call(allLeavesData, pageSize, pageIndex);
        }

        yield put(completedFetch());
    } catch (error) {
        yield put(
            setNotificationAction({
                message: error.message,
                variant: 'error'
            })
        );
        yield put(completedFetch());
    }
}

function* leaveStatusWatcher() {
    yield takeLatest(startUpdateLeaveStatus.type, updateLeaveApproveReject);
}

//Accumulator
export default function* leavesDataSaga() {
    yield all([
        call(employeeLeaveDropdownWatcher),
        call(myLeaveDataWatcher),
        call(startAllLeaveData),
        call(startSingleData),
        call(startAddEditLeaveWatcher),
        call(startAddEditLeaveWatcherAdmin),
        call(startLeaveDelete),
        call(startAllEmployeeLeaveData),
        call(start_startAddRestoreLeave),
        call(start_starOverlapppingLeave),
        call(start_EmployeeeLeaveSummaryDetails),
        call(leaveStatusWatcher)
    ]);
}
